﻿<script>
  export let className;
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  class={className}>
  <g transform="translate(3.000000, 3.000000)">
    <line x1="0.375" y1="0.37425" x2="17.625" y2="17.62425" id="Path" />
    <line x1="17.625" y1="0.37425" x2="0.375" y2="17.62425" id="Path" />
  </g>
</svg>
